import { GROUP } from '~/consts';

export const state = () => ({
  loading_search: false,
  public: [],
  dataProviderPublic: {
    criterion: [{
      operator: 'LK',
      value: '',
      criteria: 'keyword',
      custom: true
    }],
    page: {
      current: 1,
      limit: 15,
    },
    sort: []
  },
  all: []
})

export const mutations = {
  setLoading(state, val) {
    state.loading_search = val;
  },
  setPublicGroups (state, val) {
    state.public = val;
  },
  setAllGroups (state, val) {
    state.all = val;
  },
  setDataProviderPublic (state, val) {
    state.dataProviderPublic = val;
  }
}

export const actions = {
  getAllGroups ({ commit }) {
    this.$axios.post(GROUP.GET_ACADEMIC, {
      dataProvider: JSON.stringify({
        page: {
          current: 1,
          limit: 200,
        },
      },)
    }).then(({ data }) => {
      if (data.applicationSystem.code == 0) {
        commit('setAllGroups', data.data.data)
      }
    }).catch(() => {

    });
  },
  getPublicGroups ({ commit, state }, refresh = false) {
    const vm = this;

    commit('setLoading', true);
    let dataProvider = _.cloneDeep(state.dataProviderPublic);

    if (refresh) {
      dataProvider.page['current'] = 1;
    }

    const postdata = {
      dataProvider: JSON.stringify(dataProvider),
    }

    this.$axios.post(`${GROUP.GET_PUBLIC}?with_paid_group=1`, postdata)
      .then(({ data }) => {
        if (data.applicationSystem.code == 0) {
          let public_groups = collect(state.public);

          if (refresh) {
            public_groups = data.data.data;
          } else {
            public_groups = public_groups.merge(data.data.data).toArray();
          }

          commit('setPublicGroups', public_groups);
          commit('setDataProviderPublic', data.data.dataProvider);
        }

        commit('setLoading', false);
      }).catch(() => {
        commit('setLoading', false);
      });
  }
}
